<main id="main">
  <div class="row-md-2" id="header">
    <!-- (selectedlanguage)="language($event)" -->
    <app-header (newItemEvent)="sideBarDisplay($event)" [formConfig]="formConfig"></app-header>
  </div>
  <div class="d-md-flex row-md-10">
    <div [ngClass]="{ 'col-md-2': displaySideBar }" id="sidebar">
      <app-side-bar
        class="d-none d-md-block"
        *ngIf="displaySideBar"
        [formConfig]="formConfig"
      ></app-side-bar>
    </div>
    <div
      class="plansscreen"
      [ngClass]="{ 'col-md-8': displaySideBar, 'col-md-10': !displaySideBar }"
    >
      <div
        *ngFor="let package of plansData"
        style="
          max-height: calc(100vh - 100px);
          background-color: white;
          padding: 10px;
          overflow-y: auto;
        "
      >
        <div
          *ngIf="hasKeys(package.groups)"
          class="text-black text-center text-[18px] font-bold mt-4 mb-4"
        >
          {{ package.name }}
        </div>

        <div class="row" style="padding: 10px">
          <ng-container *ngIf="package.groups">
            <div
              *ngFor="let key of groupKeys"
              class="row mb-5"
              style="overflow-y: auto"
            >
              <div
                *ngFor="let group of package.groups[key]; let i = index"
                class="col-12 col-md-6"
                style="margin-bottom: 100px"
              >
                <ng-container *ngIf="group.plans">
                  <div *ngFor="let plan of group.plans; let j = index">
                    <ng-container *ngIf="plan.productAddonssNames">
                      <div
                        *ngFor="
                          let product of plan.productAddonssNames;
                          let k = index
                        "
                        class="shadow p-1 rounded w-100"
                        [ngStyle]="{
                          'background-color': plan.isBundle
                            ? group.backgroundColor
                            : plan.productAddonss[product][0].planlevel
                                .backgroundColor
                        }"
                      >
                        <div class="text-center text-white fw-bold h-4 mt-1">
                          {{ product }}
                        </div>

                        <div class="p-3">
                          <div *ngIf="plan.isBundle; else nonBundle">
                            <div
                              class="h-75 overflow-auto text-center bg-white"
                            >
                              <div
                                *ngIf="group.planLevelFeatures; else noFeatures"
                                style="height: 300px"
                              >
                                <div
                                  *ngFor="
                                    let features of group.planLevelFeatures
                                  "
                                >
                                  <div
                                    *ngIf="
                                      features.productType;
                                      else featureWithoutType
                                    "
                                  >
                                    <div
                                      *ngIf="
                                        plan.jsonData.product_type.includes(
                                          features.productType
                                        )
                                      "
                                    >
                                      <strong>{{
                                        features.feature.name
                                      }}</strong>
                                                                            <p
                                        [innerHTML]="features.description"
                                        style="font-size: 14px; margin: 0px"
                                      ></p>
                                    </div>
                                  </div>
                                  <ng-template #featureWithoutType>
                                    <strong>{{ features.feature.name }}</strong>
                                                                        <p
                                      [innerHTML]="features.description"
                                      style="font-size: 14px; margin: 0px"
                                    ></p>
                                  </ng-template>
                                </div>
                              </div>
                              <ng-template #noFeatures style="height: 300px">
                                <p
                                  [innerHTML]="
                                    plan.productAddonss[product][0].description2
                                  "
                                ></p>
                              </ng-template>
                            </div>
                          </div>
                          <ng-template #nonBundle>
                            <div
                              class="h-75 overflow-auto text-center bg-white"
                            >
                              <div
                                *ngIf="
                                  plan.productAddonss[product][0].planlevel
                                    .planLevelFeatures;
                                  else noPlanLevelFeatures
                                "
                                style="height: 300px"
                              >
                                <div
                                  *ngFor="
                                    let features of plan.productAddonss[
                                      product
                                    ][0].planlevel.planLevelFeatures
                                  "
                                >
                                  <div
                                    *ngIf="
                                      features.productType;
                                      else featureWithoutType
                                    "
                                  >
                                    <div
                                      *ngIf="
                                        plan.jsonData.product_type.includes(
                                          features.productType
                                        )
                                      "
                                    >
                                      <strong>{{
                                        features.feature.name
                                      }}</strong>
                                                                            <p
                                        [innerHTML]="features.description"
                                        style="font-size: 14px; margin: 0px"
                                      ></p>
                                    </div>
                                  </div>
                                  <ng-template #featureWithoutType>
                                    <strong>{{ features.feature.name }}</strong>
                                                                        <p
                                      [innerHTML]="features.description"
                                      style="font-size: 14px; margin: 0px"
                                    ></p>
                                  </ng-template>
                                </div>
                              </div>
                              <ng-template
                                #noPlanLevelFeatures
                                style="height: 300px"
                              >
                                <p
                                  [innerHTML]="
                                    plan.productAddonss[product][0].description2
                                  "
                                ></p>
                              </ng-template>
                            </div>
                          </ng-template>

                          <div
                            *ngFor="
                              let coverage of plan.productAddonss[product]
                            "
                          >
                            <div class="h-100 text-white fs-6">
                              <ng-container
                                *ngIf="plan.insuranceType != 'LIFE'"
                              >
                                <span class="float-end text-white">
                                  ${{ coverage.price }}<small>*</small>
                                </span>
                              </ng-container>
                              <ng-container
                                *ngIf="plan.insuranceType != 'LIFE'"
                              >
                                <input
                                  type="checkbox"
                                  id="plancheck{{
                                    plan.isBundle
                                      ? plan.id
                                      : plan.productAddonss[product][k]
                                          .planlevel.id
                                  }}"
                                  class="form-check-input"
                                  (change)="
                                    onCheckboxChange(
                                      $event,
                                      package.allowMultiple,
                                      plan.productAddonss[product][k].plan_level
                                        .disallowedPlanLevels,
                                      plan.planOptions,
                                      group.parentId,
                                      package.name,
                                      group.name,
                                      getCoverageKey(plan),
                                      0,
                                      0,
                                      0,
                                      0,
                                      $event,
                                      i,
                                      j,
                                      k,
                                      plan,
                                      plan.productAddonss[product][k],
                                      package,
                                      group,
                                      coverage.planCoverageUI
                                    )
                                  "
                                />
                                {{ coverage.planCoverageUI }}
                              </ng-container>

                              <ng-container
                                *ngIf="plan.insuranceType == 'LIFE'"
                              >
                                <div
                                  class="d-flex flex-column gap-2 text-muted my-3"
                                >
                                  <!-- Total Row -->
                                  <div
                                    class="d-flex justify-content-between fw-bold text-white"
                                  >
                                    <div>{{lang?.Total}}</div>
                                    <div class="text-end">
                                      <p class="text-end w-100 m-0">
                                        $ {{
                                          getAmount(allFormData[getCoverageKey(plan)]?.total)
                                        }}
                                      </p>
                                    </div>
                                  </div>

                                  <!-- Member Checkbox and Premium -->
                                  <div class="row g-2">
                                    <div
                                      class="col-9 d-flex gap-2 align-items-center"
                                      >
                                      <input
                                        id="member"
                                        type="checkbox"
                                        name="{{ getCoverageKey(plan)  }}-member"
                                        [ngClass]="{ 'disabled-checkbox': lifePlans.length !== 0 }"
                                        class="form-check-input {{ getCoverageKey(plan) }}-member"
                                        attr.data="{{ package.name }}##{{
                                          group.name
                                        }}##{{ getCoverageKey(plan)  }}##{{
                                          plan.productAddonss[product][k]
                                            .calculatedTax.price
                                        }}##0##0##0##{{ plan.id }}##{{
                                          plan.fusebillId
                                        }}##{{ plan.frqMonthly }}##{{
                                          package.optIn
                                        }}##{{ group.disallowedPlanLevels }}##{{
                                          group.parentId
                                        }}##{{ group.id }}##{{ plan.name }}##{{
                                          plan.planLevel
                                        }}##{{ plan.packageId }}##0##{{
                                          plan.planOptions
                                        }}##{{
                                          plan.productAddonss[product][k].id
                                        }}##{{
                                          plan.productAddonss[product][k]
                                            .plan_level.id
                                        }}##{{ plan.isBundle }}"
                                        (change)="
                                          onCheckboxChangeP(
                                            $event,
                                            (getCoverageKey(plan) ),
                                            'member',
                                            'coverage',
                                            plan.productAddonss[product][k]
                                          )
                                        "
                                      />
                                      <label
                                        class="form-check-label text-white text-uppercase"
                                        style="font-size: 14px"
                                      >
                                        {{lang?.Member}}
                                      </label>
                                    </div>
                                    <div
                                      class="col-3 text-end text-white fw-bold"
                                    >
                                      <p
                                        class="text-end w-100 m-0"
                                        style="font-size: 14px"
                                      >
                                        $ {{
                                          allFormData[getCoverageKey(plan)]?.member
                                            ?.premium | number : "1.2-2"
                                        }}
                                      </p>
                                    </div>
                                  </div>

                                  <!-- Smoker Radio Buttons -->
                                  <div class="row g-2">
                                    <div
                                      class="col-12 text-white"
                                      style="font-size: 14px"
                                    >
                                      <p style="font-size: 13px;">
                                        {{lang?.In_the_last_12_months_have_you_used_in_any_form_whatsoever_tobacco_nicotine_or_cannabis_mixed_with_tobacco}}
                                      </p>
                                      <div class="d-flex">
                                        <div class="form-check">
                                          <input
                                            id="yes"
                                            type="radio"
                                            class="member-{{
                                              getCoverageKey(plan)
                                            }}-yes"
                                            attr.data="{{ package.name }}##{{
                                              group.name
                                            }}##{{ getCoverageKey(plan) }}##{{
                                              plan.productAddonss[product][k]
                                                .calculatedTax.price
                                            }}##0##0##0##{{ plan.id }}##{{
                                              plan.fusebillId
                                            }}##{{ plan.frqMonthly }}##{{
                                              package.optIn
                                            }}##{{
                                              group.disallowedPlanLevels
                                            }}##{{ group.parentId }}##{{
                                              group.id
                                            }}##{{ plan.name }}##{{
                                              plan.planLevel
                                            }}##{{ plan.packageId }}##0##{{
                                              plan.planOptions
                                            }}##{{
                                              plan.productAddonss[product][k].id
                                            }}##{{
                                              plan.productAddonss[product][k]
                                                .plan_level.id
                                            }}##{{ plan.isBundle }}"
                                            name="member-{{
                                              getCoverageKey(plan)
                                            }}"
                                            class="form-check-input"
                                            [disabled]="
                                              isDataAvailable(
                                                getCoverageKey(plan),
                                                'member'
                                              )
                                            "
                                            [checked]="
                                              allFormData[getCoverageKey(plan)]
                                                ?.member?.isSmoker === 'yes'
                                            "
                                            value="yes"
                                            [ngClass]="{ 'disabled-checkbox': lifePlans.length !== 0 }"
                                            (change)="
                                              handleRadioChange(
                                                $event,
                                                getCoverageKey(plan),
                                                'member',
                                                plan.planOptions,
                                                plan,
                                                plan.productAddonss[product][k],
                                                package,
                                                group,
                                                plan.productAddonss[product][k]
                                                  .member
                                              )
                                            "
                                          />
                                          <label
                                            class="form-check-label text-white"
                                            >{{lang?.Yes}}</label
                                          >
                                        </div>
                                        <div class="form-check ms-3 radio-btn">
                                          <input
                                            id="no"
                                            type="radio"
                                            class="member-{{
                                              getCoverageKey(plan)
                                            }}-no"
                                            attr.data="{{ package.name }}##{{
                                              group.name
                                            }}##{{ getCoverageKey(plan) }}##{{
                                              plan.productAddonss[product][k]
                                                .calculatedTax.price
                                            }}##0##0##0##{{ plan.id }}##{{
                                              plan.fusebillId
                                            }}##{{ plan.frqMonthly }}##{{
                                              package.optIn
                                            }}##{{
                                              group.disallowedPlanLevels
                                            }}##{{ group.parentId }}##{{
                                              group.id
                                            }}##{{ plan.name }}##{{
                                              plan.planLevel
                                            }}##{{ plan.packageId }}##0##{{
                                              plan.planOptions
                                            }}##{{
                                              plan.productAddonss[product][k].id
                                            }}##{{
                                              plan.productAddonss[product][k]
                                                .plan_level.id
                                            }}##{{ plan.isBundle }}"
                                            name="member-{{
                                              getCoverageKey(plan)
                                            }}"
                                            class="form-check-input"
                                            [disabled]="
                                              isDataAvailable(
                                                getCoverageKey(plan),
                                                'member'
                                              )
                                            "
                                            [checked]="
                                              allFormData[getCoverageKey(plan)]
                                                ?.member?.isSmoker === 'no'
                                            "
                                            value="no"
                                            [ngClass]="{ 'disabled-checkbox': lifePlans.length !== 0 }"
                                            (change)="
                                              handleRadioChange(
                                                $event,
                                                getCoverageKey(plan),
                                                'member',
                                                plan.planOptions,
                                                plan,
                                                plan.productAddonss[product][k],
                                                package,
                                                group,
                                                plan.productAddonss[product][k]
                                                  .member
                                              )
                                            "
                                          />
                                          <label
                                            class="form-check-label text-white"
                                            >{{lang?.No}}</label
                                          >
                                        </div>
                                      </div>
                                    </div>

                                    <!-- Range Slider -->
                                    <div class="col-12 m-0">
                                      <p class="text-center mb-2 text-white">
                                        {{
                                          plan.productAddonss[product][k].member
                                            .maximumCoverageWithoutEvidence /
                                            1000 | number
                                        }}k
                                      </p>
                                      <div class="range-slider-container">
                                        <div
                                          class="range-slider-wrapper position-relative"
                                          >
                                          <!-- [(ngModel)]="allFormData[getCoverageKey(plan)].coverage.coverageValue" -->
                                          <input
                                          [ngModelOptions]="{ standalone: true }"
                                          [(ngModel)]="plan.productAddonss[product][k].member.maximumCoverageWithoutEvidence"
                                            type="range"
                                            class="form-range"
                                            attr.data="{{ package.name }}##{{
                                              group.name
                                            }}##{{ getCoverageKey(plan) }}##{{
                                              plan.productAddonss[product][k]
                                                .calculatedTax.price
                                            }}##0##0##0##{{ plan.id }}##{{
                                              plan.fusebillId
                                            }}##{{ plan.frqMonthly }}##{{
                                              package.optIn
                                            }}##{{
                                              group.disallowedPlanLevels
                                            }}##{{ group.parentId }}##{{
                                              group.id
                                            }}##{{ plan.name }}##{{
                                              plan.planLevel
                                            }}##{{ plan.packageId }}##0##{{
                                              plan.planOptions
                                            }}##{{
                                              plan.productAddonss[product][k].id
                                            }}##{{
                                              plan.productAddonss[product][k]
                                                .plan_level.id
                                            }}##{{ plan.isBundle }}"
                                            id="{{
                                              getCoverageKey(plan)
                                            }}-member-rangeSlider"
                                            name="{{
                                              getCoverageKey(plan)
                                            }}-member-rangeSlider"
                                            [ngModelOptions]="{
                                              standalone: true
                                            }"
                                            [disabled]="
                                              isDataAvailable(
                                                getCoverageKey(plan),
                                                'member',
                                                'isSmoker'
                                              )
                                            "
                                            (change)="
                                              handleRangeChange(
                                                $event,
                                                getCoverageKey(plan),
                                                'member',
                                                plan.planOptions,
                                                plan,
                                                plan.productAddonss[product][k],
                                                package,
                                                group,
                                                $event,
                                                plan.productAddonss[product][k]
                                                  .member
                                              )
                                            "
                                            [min]="0"
                                            [max]="
                                              plan.productAddonss[product][k]
                                                .member
                                                .maximumCoverageWithEvidence
                                            "
                                            [step]="
                                              plan.productAddonss[product][k]
                                                .member.minimumCoverage
                                            "
                                            [style.background]="
                                              getSliderBackground(
                                                plan.productAddonss[product][k]
                                                  .member
                                                  .maximumCoverageWithoutEvidence,
                                                plan.productAddonss[product][k]
                                                  .member
                                                  .maximumCoverageWithEvidence,
                                                plan.productAddonss[product][k]
                                                  .member.minimumCoverage,
                                                plan.productAddonss[product][k]
                                                  .member.defaultRange
                                              )
                                            "
                                          />

                                          <!-- Range Labels -->
                                          <div class="range-names">
                                            <span
                                              class="name-label text-white"
                                              [ngStyle]="{
                                                'width.%': greenValue,
                                              }"
                                              >{{lang?.Guaranteed_Approval}}</span
                                            >
                                            <span
                                              class="name-label text-white"
                                              *ngIf="showyellowbar"
                                              [ngStyle]="{ 'right.%': 0, 'top':'-30px' }"
                                              >{{lang?.Pending_Approval}}</span
                                            >
                                                                                      </div>
                                          <div class="range-ticks1">
                                            <span
                                              *ngFor="let val of rangeValues"
                                              class="tick1"
                                            ></span>
                                          </div>
                                        </div>
                                        <div class="range-labels">
                                          <span
                                            *ngFor="let val of rangeValues"
                                            class="range-label"
                                            >${{ val / 1000 }}k</span
                                          >
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                                                <div
                                  *ngIf="having_spouse"
                                  class="d-flex flex-column gap-2 text-muted my-3"
                                >
                                  <div class="row g-2">
                                    <div
                                      class="col-9 d-flex gap-2 align-items-center"
                                    >
                                      <input
                                        id="spouse"
                                        type="checkbox"
                                        name="{{ getCoverageKey(plan) }}-spouse"
                                        [ngClass]="{ 'disabled-checkbox': lifePlans.length !== 0 }"
                                        class="form-check-input {{
                                          getCoverageKey(plan)
                                        }}-spouse"
                                        attr.data="{{ package.name }}##{{
                                          group.name
                                        }}##{{ getCoverageKey(plan) }}##{{
                                          plan.productAddonss[product][k]
                                            .calculatedTax.price
                                        }}##0##0##0##{{ plan.id }}##{{
                                          plan.fusebillId
                                        }}##{{ plan.frqMonthly }}##{{
                                          package.optIn
                                        }}##{{ group.disallowedPlanLevels }}##{{
                                          group.parentId
                                        }}##{{ group.id }}##{{ plan.name }}##{{
                                          plan.planLevel
                                        }}##{{ plan.packageId }}##0##{{
                                          plan.planOptions
                                        }}##{{
                                          plan.productAddonss[product][k].id
                                        }}##{{
                                          plan.productAddonss[product][k]
                                            .plan_level.id
                                        }}##{{ plan.isBundle }}"
                                        [disabled]="
                                          isDataAvailableSpouse(
                                            getCoverageKey(plan),
                                            'spouse'
                                          )
                                        "
                                        (change)="
                                          onCheckboxChangeP(
                                            $event,
                                            getCoverageKey(plan),
                                            'spouse',
                                            'coverage',
                                            plan.productAddonss[product][k]
                                          )
                                        "
                                      />
                                      <label
                                        class="form-check-label text-white fw-bold text-uppercase"
                                        style="font-size: 14px"
                                      >
                                        {{lang?.Spouse}}
                                      </label>
                                    </div>

                                    <div
                                      class="col-3 text-end text-white fw-bold"
                                    >
                                      <p
                                        class="text-end w-100 m-0"
                                        style="font-size: 14px"
                                      >
                                        $ {{
                                          allFormData[getCoverageKey(plan)]?.spouse
                                            ?.premium | number : "1.2-2"
                                        }}
                                      </p>
                                    </div>
                                  </div>

                                  <div class="row g-2">
                                    <div class="col-12 text-white">
                                      <p style="font-size: 13px">
                                        {{lang?.In_the_last_12_months_have_you_used_in_any_form_whatsoever_tobacco_nicotine_or_cannabis_mixed_with_tobacco}}
                                      </p>
                                      <div class="d-flex gap-3">
                                        <div class="form-check">
                                          <input
                                            id="yes"
                                            type="radio"
                                            class="spouse-{{
                                              getCoverageKey(plan)
                                            }}-yes"
                                            class="form-check-input spouse-{{
                                              getCoverageKey(plan)
                                            }}-yes"
                                            attr.data="{{ package.name }}##{{
                                              group.name
                                            }}##{{ getCoverageKey(plan) }}##{{
                                              plan.productAddonss[product][k]
                                                .calculatedTax.price
                                            }}##0##0##0##{{ plan.id }}##{{
                                              plan.fusebillId
                                            }}##{{ plan.frqMonthly }}##{{
                                              package.optIn
                                            }}##{{
                                              group.disallowedPlanLevels
                                            }}##{{ group.parentId }}##{{
                                              group.id
                                            }}##{{ plan.name }}##{{
                                              plan.planLevel
                                            }}##{{ plan.packageId }}##0##{{
                                              plan.planOptions
                                            }}##{{
                                              plan.productAddonss[product][k].id
                                            }}##{{
                                              plan.productAddonss[product][k]
                                                .plan_level.id
                                            }}##{{ plan.isBundle }}"
                                            [disabled]="
                                              isDataAvailableSpouseDataa(
                                                getCoverageKey(plan),
                                                'spouse'
                                              )
                                            "
                                            value="yes"
                                            name="spouse-{{
                                              getCoverageKey(plan)
                                            }}"
                                            [checked]="
                                              allFormData[getCoverageKey(plan)]
                                                ?.spouse?.isSmoker === 'yes'
                                            "
                                            [ngClass]="{ 'disabled-checkbox': lifePlans.length !== 0 }"
                                            (change)="
                                              handleRadioChange(
                                                $event,
                                                getCoverageKey(plan),
                                                'spouse',
                                                plan.planOptions,
                                                plan,
                                                plan.productAddonss[product][k],
                                                package,
                                                group,
                                                plan.productAddonss[product][k]
                                                  .spouse
                                              )
                                            "
                                          />
                                          <label
                                            class="form-check-label text-white"
                                            >{{lang?.Yes}}</label
                                          >
                                        </div>
                                        <div class="form-check">
                                          <input
                                            id="no"
                                            type="radio"
                                            class="form-check-input spouse-{{
                                              getCoverageKey(plan)
                                            }}-no"
                                            attr.data="{{ package.name }}##{{
                                              group.name
                                            }}##{{ getCoverageKey(plan) }}##{{
                                              plan.productAddonss[product][k]
                                                .calculatedTax.price
                                            }}##0##0##0##{{ plan.id }}##{{
                                              plan.fusebillId
                                            }}##{{ plan.frqMonthly }}##{{
                                              package.optIn
                                            }}##{{
                                              group.disallowedPlanLevels
                                            }}##{{ group.parentId }}##{{
                                              group.id
                                            }}##{{ plan.name }}##{{
                                              plan.planLevel
                                            }}##{{ plan.packageId }}##0##{{
                                              plan.planOptions
                                            }}##{{
                                              plan.productAddonss[product][k].id
                                            }}##{{
                                              plan.productAddonss[product][k]
                                                .plan_level.id
                                            }}##{{ plan.isBundle }}"
                                            [disabled]="
                                              isDataAvailableSpouseDataa(
                                                getCoverageKey(plan),
                                                'spouse'
                                              )
                                            "
                                            value="no"
                                            name="spouse-{{
                                              getCoverageKey(plan)
                                            }}"
                                            [checked]="
                                              allFormData[getCoverageKey(plan)]
                                                ?.spouse?.isSmoker === 'no'
                                            "
                                            [ngClass]="{ 'disabled-checkbox': lifePlans.length !== 0 }"
                                            (change)="
                                              handleRadioChange(
                                                $event,
                                                getCoverageKey(plan),
                                                'spouse',
                                                plan.planOptions,
                                                plan,
                                                plan.productAddonss[product][k],
                                                package,
                                                group,
                                                plan.productAddonss[product][k]
                                                  .spouse
                                              )
                                            "
                                          />
                                          <label
                                            class="form-check-label text-white"
                                            >{{lang?.No}}</label
                                          >
                                        </div>
                                      </div>
                                    </div>

                                    <div class="col-12 m-0">
                                      <p class="text-center mb-2 text-white">
                                        {{
                                          plan.productAddonss[product][k].spouse
                                            .maximumCoverageWithoutEvidence /
                                            1000 | number
                                        }}k
                                      </p>
                                      <div class="range-slider-container">
                                        <div class="range-slider-wrapper">
                                          <input
                                          [ngModelOptions]="{ standalone: true }"
                                          [(ngModel)]="plan.productAddonss[product][k].spouse.maximumCoverageWithoutEvidence"
                                            type="range"
                                            class="form-range"
                                            attr.data="{{ package.name }}##{{
                                              group.name
                                            }}##{{ getCoverageKey(plan) }}##{{
                                              plan.productAddonss[product][k]
                                                .calculatedTax.price
                                            }}##0##0##0##{{ plan.id }}##{{
                                              plan.fusebillId
                                            }}##{{ plan.frqMonthly }}##{{
                                              package.optIn
                                            }}##{{
                                              group.disallowedPlanLevels
                                            }}##{{ group.parentId }}##{{
                                              group.id
                                            }}##{{ plan.name }}##{{
                                              plan.planLevel
                                            }}##{{ plan.packageId }}##0##{{
                                              plan.planOptions
                                            }}##{{
                                              plan.productAddonss[product][k].id
                                            }}##{{
                                              plan.productAddonss[product][k]
                                                .plan_level.id
                                            }}##{{ plan.isBundle }}"
                                            [disabled]="
                                              isDataAvailable(
                                                getCoverageKey(plan),
                                                'spouse',
                                                'isSmoker'
                                              )
                                            "
                                            id="{{
                                              getCoverageKey(plan)
                                            }}-spouse-rangeSlider"
                                            name="{{
                                              getCoverageKey(plan)
                                            }}-spouse-rangeSlider"
                                            (change)="
                                              handleRangeChange(
                                                $event,
                                                getCoverageKey(plan),
                                                'spouse',
                                                plan.planOptions,
                                                plan,
                                                plan.productAddonss[product][k],
                                                package,
                                                group,
                                                $event,
                                                plan.productAddonss[product][k]
                                                  .spouse
                                              )
                                            "
                                            [min]="0"
                                            [max]="
                                              plan.productAddonss[product][k]
                                                .spouse
                                                .maximumCoverageWithEvidence
                                            "
                                            [step]="
                                              plan.productAddonss[product][k]
                                                .spouse.minimumCoverage
                                            "
                                            [style.background]="
                                              getSliderBackground(
                                                plan.productAddonss[product][k]
                                                  .spouse
                                                  .maximumCoverageWithoutEvidence,
                                                plan.productAddonss[product][k]
                                                  .spouse
                                                  .maximumCoverageWithEvidence,
                                                plan.productAddonss[product][k]
                                                  .spouse.minimumCoverage,
                                                plan.productAddonss[product][k]
                                                  .spouse.defaultRange
                                              )
                                            "
                                          />

                                          <div class="range-names">
                                            <span
                                              class="name-label text-white"
                                              [ngStyle]="{
                                                'width.%': greenValue,
                                              }"
                                              >{{lang?.Guaranteed_Approval}}</span
                                            >
                                            <span
                                              class="name-label text-white"
                                              [ngStyle]="{ 'right.%': 0, 'top':'-30px' }"
                                              >{{lang?.Pending_Approval}}</span
                                            >
                                          </div>
                                          <div class="range-ticks1">
                                            <span
                                              *ngFor="let val of rangeValues"
                                              class="tick1"
                                            ></span>
                                          </div>
                                        </div>
                                        <div class="range-labels">
                                          <span
                                            *ngFor="let val of rangeValues"
                                            class="range-label"
                                            >${{ val / 1000 }}k</span
                                          >
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </ng-container>
                            </div>
                          </div>
                        </div>
                      </div>
                    </ng-container>
                  </div>
                </ng-container>
              </div>
            </div>
          </ng-container>
        </div>
                <button
          id="submitButton"
          class="btn btn-sm btn-light"
          style="float: left"
          (click)="navigateToHome()"
        >
        {{lang?.Previous}}
        </button>
        <div class="d-flex justify-content-end" *ngIf="plansData.length > 0">
          <button
            id="submitButton"
            class="btn btn-sm btn-light"
            style="margin-right: 10px"
            data-bs-toggle="modal"
            data-bs-target="#questionnaire"
            [disabled]="lifeMember &&
            lifeSpouse &&
            criticalMember &&
            criticalSpouse"
            (click)="questionnaireBtn()"
          >
            {{lang?.Questionnaire}}
          </button>
          <button
            id="submitButton"
            class="btn btn-sm btn-light"
            [disabled]="!lifeMember ||
            !lifeSpouse ||
            !criticalMember ||
            !criticalSpouse"
            (click)="lifePlans.length==0?addNewPlans():updatePlans()"
          >
            {{lang?.Submit}}
          </button>
        </div>
      </div>
    </div>
    <div class="d-none d-md-block col-md-2" id="sidebar">
      <app-welcome-bar></app-welcome-bar>
    </div>
  </div>
</main>

<div
  id="questionnaire"
  class="modal modalposition modal-md"
  data-bs-backdrop="static"
>
  <div class="modal-dialog modal-dialog-centered" style="max-width: 900px; max-height: 100vh;">
    <div class="modal-content">
      <div class="modal-header" id="backgroundColor">
        <h6 class="modal-title">{{lang?.Medical_Questionnaire}}</h6>
        <i
          #closeQuestionnaire
          class="bi bi-x-circle"
          role="button"
          aria-hidden="true"
          data-bs-dismiss="modal"
        ></i>
      </div>
      <div class="modal-body">
        <div
        style="
          max-height: calc(100vh - 200px);
          background-color: white;
          padding: 10px;
          overflow-y: auto;
          padding-top: 0px;
        "
      >
      <!-- style="position:sticky; top:0px; background:white; z-index:999;" -->
            <!-- style="position:sticky; top:36px; background:white; z-index:999;" -->
        <p>
                    {{lang?.Please_complete_and_submit_questionnaire_for_approval_when_coverage_requested_exceeds_guaranteed_amount_The_premium_for_the_exceeding_coverage_will_be_effective_upon_approval_of_your_application}}
        </p>
        

        <form [formGroup]="insuranceForm">
          <table>
                        <tr style="position:sticky; top:0px; z-index:999; margin-top:0px;">
              <td></td>
              <td></td>
              <td class="text-center">{{lang?.Member}}</td>
              <td class="text-center" *ngIf="isSpouse">{{lang?.Spouse}}</td>
            </tr>
            <tr>
              <td [colSpan]="2" class="text-end" style="padding-right:30px">{{lang?.Place_of_Birth}}<span style="color: red">*</span></td>
              <td class="text-center">
                <input
                  class="form-control text-capitalize"
                  placeholder="{{lang?.Place_of_Birth}}"
                  [ngModelOptions]="{ standalone: true }"
                  [(ngModel)]="memberDetails.pob"
                  onkeydown="return /[a-z\s]/i.test(event.key)"
                />
              </td>
              <td class="text-center" *ngIf="isSpouse">
                <input
                  class="form-control text-capitalize"
                  placeholder="{{lang?.Place_of_Birth}}"
                  [ngModelOptions]="{ standalone: true }"
                  [(ngModel)]="spouseDetails.pob"
                  onkeydown="return /[a-z\s]/i.test(event.key)"
                />
              </td>
            </tr>
            <tr>
              <td [colSpan]="2" class="text-end" style="padding-right:30px">{{lang?.Occupation}}<span style="color: red">*</span></td>
              <td class="text-center">
                <input
                  class="form-control text-capitalize"
                  placeholder="{{lang?.Occupation}}"
                  [ngModelOptions]="{ standalone: true }"
                  [(ngModel)]="memberDetails.occupation"
                  onkeydown="return /[a-z\s]/i.test(event.key)"
                />
              </td>
              <td class="text-center" *ngIf="isSpouse">
                <input
                  class="form-control text-capitalize"
                  placeholder="{{lang?.Occupation}}"
                  [ngModelOptions]="{ standalone: true }"
                  [(ngModel)]="spouseDetails.occupation"
                  onkeydown="return /[a-z\s]/i.test(event.key)"
                />
              </td>
            </tr>
            <tr>
                            <td [colSpan]="2" class="text-end" style="padding-right:30px">{{lang?.Height}}<span style="color: red">*</span></td>
              <td>
              <div class="input-group">
                <input
                  type="number"
                  id="height"
                  formControlName="memberHeight"
                  class="form-control"
                  placeholder="{{lang?.Enter_height}}"
                  min="0"
                />
                <div class="input-group-append">
                  <select
                    [(ngModel)]="memberHeightUnit"
                    [ngModelOptions]="{ standalone: true }"
                    class="form-control"
                  >
                    <option value="ft">ft</option>
                    <option value="cm">cm</option>
                  </select>
                </div>
              </div>
              <div
                *ngIf="
                  insuranceForm.get('memberHeight')?.invalid &&
                  insuranceForm.get('memberHeight')?.touched
                "
                class="help-block text-danger"
              >
                {{lang?.Member_height_is_required}}
              </div>
            </td>
              <td *ngIf="isSpouse">
                <div class="input-group">
                  <input
                    type="number"
                    id="height"
                    formControlName="spouseHeight"
                    class="form-control"
                    placeholder="{{lang?.Enter_height}}"
                    min="0"
                  />
                  <div class="input-group-append">
                    <select
                      [(ngModel)]="spouseHeightUnit"
                      [ngModelOptions]="{ standalone: true }"
                      class="form-control"
                    >
                      <option value="ft">ft</option>
                      <option value="cm">cm</option>
                    </select>
                  </div>
                </div>
                <div
                  *ngIf="
                    insuranceForm.get('spouseHeight')?.invalid &&
                    insuranceForm.get('spouseHeight')?.touched
                  "
                  class="help-block text-danger"
                >
                  {{lang?.Spouse_height_is_required}}
                </div>
              </td>
            </tr>
            <tr>
                            <td [colSpan]="2" class="text-end" style="padding-right:30px">{{lang?.Weight}}<span style="color: red">*</span></td>
              <td>
                <div class="input-group">
                  <input
                    type="number"
                    id="weight"
                    formControlName="memberWeight"
                    class="form-control"
                    placeholder="{{lang?.Enter_weight}}"
                    min="0"
                  />
                  <div class="input-group-append">
                    <select
                      [(ngModel)]="memberweightUnit"
                      [ngModelOptions]="{ standalone: true }"
                      class="form-control"
                    >
                      <option value="lbs">lbs</option>
                      <option value="kgs">kgs</option>
                    </select>
                  </div>
                  </div>
                <div
                  *ngIf="
                    insuranceForm.get('memberWeight')?.invalid &&
                    insuranceForm.get('memberWeight')?.touched
                  "
                  class="help-block text-danger"
                >
                  {{lang?.Member_weight_is_required}}
                </div>
              </td>
              <td *ngIf="isSpouse">
                <div class="input-group">
                  <input
                    type="number"
                    id="weight"
                    formControlName="spouseWeight"
                    class="form-control"
                    placeholder="{{lang?.Enter_weight}}"
                    min="0"
                  />
                  <div class="input-group-append">
                    <select
                      [(ngModel)]="spouseWeightUnit"
                      [ngModelOptions]="{ standalone: true }"
                      class="form-control"
                    >
                      <option value="lbs">lbs</option>
                      <option value="kgs">kgs</option>
                    </select>
                  </div>
                  </div>
                <div
                  *ngIf="
                    insuranceForm.get('spouseWeight')?.invalid &&
                    insuranceForm.get('spouseWeight')?.touched
                  "
                  class="help-block text-danger"
                >
                  {{lang?.Spouse_weight_is_required}}
                </div>
              </td>
            </tr>

            <!-- Repeat similar structure for all questions -->
            <ng-container *ngFor="let question of questions; let i = index">
              <tr>
                                <td [ngStyle]="{ width: isSpouse ? '50%' : '75%' }" [colSpan]="2">
                  {{ question.label }}<span style="color: red">*</span>
                </td>
                <td style="width: 25%;" class="text-center">
                  <input 
                    [attr.disabled]="question.key == 3 ? true : null"
                    type="radio"
                    formControlName="memberQuestion{{ i + 1 }}"
                    value="yes"
                  />
                  {{lang?.Yes}}
                  <input 
                    [attr.disabled]="question.key == 3 ? true : null"
                    type="radio"
                    formControlName="memberQuestion{{ i + 1 }}"
                    value="no"
                  />
                  {{lang?.No}}
                </td>
                <td style="width: 25%;" class="text-center" *ngIf="isSpouse">
                  <input
                    [attr.disabled]="question.key == 3 ? true : null"
                    type="radio"
                    formControlName="spouseQuestion{{ i + 1 }}"
                    value="yes"
                  />
                  {{lang?.Yes}}
                  <input
                    [attr.disabled]="question.key == 3 ? true : null"
                    type="radio"
                    formControlName="spouseQuestion{{ i + 1 }}"
                    value="no"
                  />
                  {{lang?.No}}
                </td>
              </tr>
              <tr>
                <td class="p-0"></td>
                <td colspan="2" class="p-0">
                  <div
                    *ngIf="
                      insuranceForm.get('memberQuestion' + (i + 1))?.invalid &&
                      insuranceForm.get('memberQuestion' + (i + 1))?.touched
                    "
                    class="help-block text-danger"
                  >
                    {{lang?.This_question_is_required}}
                  </div>
                  <div
                    *ngIf="
                      insuranceForm.get('spouseQuestion' + (i + 1))?.invalid &&
                      insuranceForm.get('spouseQuestion' + (i + 1))?.touched
                    "
                    class="help-block text-danger"
                  >
                    {{lang?.This_question_is_required}}
                  </div>
                </td>
              </tr>
              <tr>
                                  <td [colSpan]="isSpouse?4:3" class="p-0">
                  <div class="row p-2" *ngIf="isConditionMetMember(i + 1)">
                    <div class="col-12">
                      <label
                        >{{lang?.Member_Details_include_dates_duration_and_names_and_addresses_of_all_doctors_hospitals_etc}}<span
                          style="color: red"
                          >*</span
                        ></label
                      >
                      <textarea
                        [rows]="3"
                        type="text"
                        class="form-control"
                        id="licenseNumber"
                        [ngModelOptions]="{ standalone: true }"
                        [(ngModel)]="answers[i].additionalDetails"
                      ></textarea>
                    </div>
                  </div>
                  <div class="row p-2" *ngIf="isConditionMetSpouse(i + 1)">
                    <div class="col-12">
                      <label
                        >Spouse Details (include dates, duration and names and
                        addresses of all doctors, hospitals, etc.).<span
                          style="color: red"
                          >*</span
                        ></label
                      >
                      <textarea
                        [rows]="3"
                        type="text"
                        class="form-control"
                        id="licenseNumber"
                        [ngModelOptions]="{ standalone: true }"
                        [(ngModel)]="answers1[i].additionalDetails"
                      ></textarea>
                    </div>
                  </div>
                </td>
              </tr>
            </ng-container>
          </table>
        </form>
        <br />
        
        <form [formGroup]="familyForm">
          <div class="row mt-4">
            <h6 class="col-12" style="text-decoration:underline">
              {{lang?.FAMILY_HISTORY_QUESTION_MUST_ALWAYS_BE_COMPLETED_WHEN_APPLYING}}
            </h6>
                        <p [ngClass]="{ 'col-8': isSpouse, 'col-10': !isSpouse }">
              {{lang?.Have_any_of_your_natural_parents_brothers_or_sisters_ever_undergone_bypass_surgery_or_suffered_from_any_of_the_following_conditions_Heart_attack_angina_or_any_other_heart_condition_stroke_polycystic_kidney_disease_diabetes_cancer_if_Yes_specify_type_Alzeimer_s_disease_Parkinson_s_disease_multiple_sclerosis_amyotrophic_lateral_sclerosis_ALS_Huntington_s_disease_alcoholism_nervous_or_mental_disorder_or_any_other_hereditary_disease}}
            </p>
            <div class="col-2 d-flex flex-column">
              <p>{{lang?.Member}}</p>
              <div>
                <input
                  name="member_radio"
                  type="radio"
                  (change)="changeFamilyMember(true)"
                  formControlName="memberHasConditions"
                  [value]="true"
                />
                {{lang?.Yes}} &nbsp;
                <input
                  name="member_radio"
                  type="radio"
                  (change)="changeFamilyMember(false)"
                  formControlName="memberHasConditions"
                  [value]="false"
                />
                {{lang?.No}}
              </div>
            </div>
            <div class="col-2 d-flex flex-column" *ngIf="isSpouse">
              <p>{{lang?.Spouse}}</p>
              <div>
                <input
                  name="spouse_radio"
                  type="radio"
                  (change)="changeFamilySpouse(true)"
                  formControlName="spouseHasConditions"
                  [value]="true"
                />
                {{lang?.Yes}} &nbsp;
                <input
                  name="spouse_radio"
                  type="radio"
                  (change)="changeFamilySpouse(false)"
                  formControlName="spouseHasConditions"
                  [value]="false"
                />
                {{lang?.No}}
              </div>
            </div>
            <div
              *ngIf="
                (familyForm.get('memberHasConditions')?.invalid &&
                  familyForm.get('memberHasConditions')?.touched) ||
                (familyForm.get('spouseHasConditions')?.invalid &&
                  familyForm.get('spouseHasConditions')?.touched)
              "
              class="help-block text-danger"
            >
              {{lang?.This_question_is_required}}
            </div>
          </div>
        </form>
        <div class="container">
          <table
            class="table table-bordered"
            *ngIf="isFamilyMember || isFamilySpouse"
          >
            <thead>
              <tr>
                <th></th>
                <th colspan="3" class="text-center" *ngIf="isFamilyMember">
                  {{lang?.Member}}
                </th>
                <th colspan="3" class="text-center" *ngIf="isFamilySpouse">
                  {{lang?.Spouse}}
                </th>
              </tr>
              <tr>
                <th></th>
                <th *ngIf="isFamilyMember">{{lang?.Condition}}</th>
                <th *ngIf="isFamilyMember">{{lang?.Age_at_Onset_Diagnosis}}</th>
                <th *ngIf="isFamilyMember">{{lang?.Age_at_Death_if_applicable}}</th>
                <th *ngIf="isFamilySpouse">{{lang?.Condition}}</th>
                <th *ngIf="isFamilySpouse">{{lang?.Age_at_Onset_Diagnosis}}</th>
                <th *ngIf="isFamilySpouse">{{lang?.Age_at_Death_if_applicable}}</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of familyData">
                <td>{{ item.label }}</td>

                <!-- Family Member Inputs -->
                <ng-container *ngIf="isFamilyMember">
                  <td>
                    <input
                      type="text"
                      class="form-control"
                      [(ngModel)]="familyMember[item.key].condition"
                    />
                  </td>
                  <td>
                    <!-- placeholder="MM-DD-YYYY" -->
                    <!-- bsDatepicker
                    [bsConfig]="{ dateInputFormat: 'MMM-DD-YYYY',showWeekNumbers: false }"
                    (keypress)="dobOnly($event)" -->
                    <input
                      type="text"
                      class="form-control"
                      [(ngModel)]="familyMember[item.key].ageAtOnset"
                    />
                  </td>
                  <td>
                    <!-- placeholder="MM-DD-YYYY" -->
                    <!-- bsDatepicker
                    [bsConfig]="{ dateInputFormat: 'MMM-DD-YYYY',showWeekNumbers: false }"
                    (keypress)="dobOnly($event)" -->
                    <input
                      type="text"
                      class="form-control"
                      [(ngModel)]="familyMember[item.key].ageAtDeath"
                    />
                  </td>
                </ng-container>

                <!-- Family Spouse Inputs -->
                <ng-container *ngIf="isFamilySpouse">
                  <td>
                    <input
                      type="text"
                      class="form-control"
                      [(ngModel)]="familySpouse[item.key].condition"
                    />
                  </td>
                  <td>
                    <!-- type="text"
                    placeholder="MM-DD-YYYY"
                    bsDatepicker
                    [bsConfig]="{ dateInputFormat: 'MMM-DD-YYYY',showWeekNumbers: false }"
                    (keypress)="dobOnly($event)" -->
                    <input
                      class="form-control"
                      [(ngModel)]="familySpouse[item.key].ageAtOnset"
                    />
                  </td>
                  <td>
                    <!-- type="text"
                    placeholder="MM-DD-YYYY"
                    bsDatepicker
                    [bsConfig]="{ dateInputFormat: 'MMM-DD-YYYY',showWeekNumbers: false }"
                    (keypress)="dobOnly($event)" -->
                    <input
                      class="form-control"
                      [(ngModel)]="familySpouse[item.key].ageAtDeath"
                    />
                  </td>
                </ng-container>
              </tr>
            </tbody>
          </table>
        </div>
        <div
          *ngIf="isAtleastOneMember || isAtleastOneSpouse"
          class="help-block text-danger"
        >
          {{
            isAtleastOneMember ? lang?.Please_enter_at_least_one_member_s_condition_and_Age_at_Onset_Diagnosis : isAtleastOneSpouse ? lang?.Please_enter_at_least_one_member_s_condition_and_Age_at_Onset_Diagnosis : ""
          }}
        </div>

        <h6  style="text-decoration:underline">{{lang?.PERSONAL_PHYSICIAN_INFORMATION}}</h6>
        <p style="font-weight: bold">{{lang?.Member_s_Personal_Physician_Information}}</p>
        <form [formGroup]="physicianForm">
          <!-- Personal Physician's Name -->
          <div class="row">
            <div class="col-12 col-md-8">
              <div class="form-group">
                <label for="Personal_Physician_Name"
                  >{{lang?.Personal_Physician_s_Name}}<span style="color: red"
                    >*</span
                  ></label
                >
                <input
                  type="text"
                  class="form-control text-capitalize"
                  id="Personal_Physician_Name"
                  placeholder="{{lang?.Personal_Physician_s_Name}}"
                  formControlName="name"
                />
                <div
                  *ngIf="
                    physicianForm.get('name')?.invalid &&
                    (physicianForm.get('name').dirty ||
                      physicianForm.get('name')?.touched)
                  "
                >
                  <small
                    class="text-danger"
                    *ngIf="physicianForm.get('name').errors.required"
                    >{{lang?.Name_is_required}}</small
                  >
                </div>
              </div>
            </div>
            <!-- Telephone -->
            <div class="col-12 col-md-4">
              <div class="form-group">
                <label for="Telephone"
                  >{{lang?.Telephone}}<span style="color: red">*</span></label
                >
                <input
                  type="text"
                  class="form-control"
                  id="Telephone"
                  placeholder="{{lang?.Telephone}}"
                  formControlName="number"
                  maxlength="17"
                />
                <div
                  *ngIf="
                    physicianForm.get('number')?.invalid &&
                    (physicianForm.get('number').dirty ||
                      physicianForm.get('number')?.touched)
                  "
                >
                  <small
                    class="text-danger"
                    *ngIf="physicianForm.get('number').errors.required"
                    >{{lang?.Telephone_is_required}}</small
                  >
                </div>
                <small
                  class="text-danger"
                  *ngIf="
                    physicianForm.get('number')?.hasError('invalidPhoneNumber')
                  "
                >
                  {{lang?.Telephone_should_contain_exactly_10_digits}}
                </small>
              </div>
            </div>
          </div>
          <!-- Address Details -->
          <div class="row">
            <div class="col-12 col-md-5">
              <div class="form-group">
                <label for="Street_Address"
                  >{{lang?.Street_Address}}<span style="color: red">*</span></label
                >
                <input
                  type="text"
                  class="form-control"
                  id="Street_Address"
                  placeholder="{{lang?.Street_Address}}"
                  formControlName="streetAddress"
                />
                <div
                  *ngIf="
                    physicianForm.get('streetAddress')?.invalid &&
                    (physicianForm.get('streetAddress').dirty ||
                      physicianForm.get('streetAddress')?.touched)
                  "
                >
                  <small
                    class="text-danger"
                    *ngIf="physicianForm.get('streetAddress').errors.required"
                    >{{lang?.Street_Address_is_required}}</small
                  >
                </div>
              </div>
            </div>
            <div class="col-12 col-md-3">
              <div class="form-group">
                <label for="City">{{lang?.City}}<span style="color: red">*</span></label>
                <input
                  type="text"
                  class="form-control text-capitalize"
                  id="City"
                  placeholder="{{lang?.City}}"
                  formControlName="city"
                />
                <div
                  *ngIf="
                    physicianForm.get('city')?.invalid &&
                    (physicianForm.get('city').dirty ||
                      physicianForm.get('city')?.touched)
                  "
                >
                  <small
                    class="text-danger"
                    *ngIf="physicianForm.get('city').errors.required"
                    >{{lang?.City_is_required}}</small
                  >
                </div>
              </div>
            </div>
            <div class="col-12 col-md-2">
              <div class="form-group">
                <label for="Province"
                  >{{lang?.Province}}<span style="color: red">*</span></label
                >
                <select
                  class="form-control"
                  id="Province"
                  formControlName="province"
                  (change)="provincelist($event)"
                >
                  <option value disabled>{{lang?.Select}}</option>
                  <option *ngFor="let province of provinceList">
                    {{ province }}
                  </option>
                </select>
                <div
                  *ngIf="
                    physicianForm.get('province')?.invalid &&
                    (physicianForm.get('province').dirty ||
                      physicianForm.get('province')?.touched)
                  "
                >
                  <small
                    class="text-danger"
                    *ngIf="physicianForm.get('province').errors.required"
                    >{{lang?.Province_is_required}}</small
                  >
                </div>
              </div>
            </div>
            <div class="col-12 col-md-2">
              <div class="form-group">
                <label for="Postal_Code"
                  >{{lang?.Postal_Code}}<span style="color: red">*</span></label
                >
                <input
                  type="text"
                  class="form-control"
                  id="Postal_Code"
                  placeholder="{{lang?.Postal_Code}}"
                  formControlName="postalCode"
                  (input)="changeTextToUppercase($event)"
                />
                <div
                  *ngIf="
                    physicianForm.get('postalCode')?.invalid &&
                    (physicianForm.get('postalCode').dirty ||
                    physicianForm.get('postalCode')?.touched)
                  "
                >
                  <small
                    class="text-danger"
                    *ngIf="physicianForm.get('postalCode').errors.required"
                    >{{lang?.Postal_Code_is_required}}</small
                  >
                                  </div>
                <div class="help-block text-danger" 
                  *ngIf="((physicianForm.get('postalCode').touched && physicianForm.get('postalCode').hasError('invalidPostalCode')) || 
                    physicianForm.get('postalCode').invalid || invalidpostalcodeprivince)">
                  {{lang?.Enter_valid_Postal_Code}}
                </div>
              </div>
            </div>
          </div>
          <!-- Consultation Details -->
          <div class="row">
            <div class="col-12 col-md-5">
              <div class="form-group">
                <label for="date_last_consulted"
                  >{{lang?.Date_last_consulted_ANY_Doctor_dd_mmm_yyyy}}<span
                    style="color: red"
                    >*</span
                  ></label
                >
                <input
                  type="text"
                  placeholder="MM-DD-YYYY"
                  class="form-control text-capitalize"
                  formControlName="dateLastConsulted"
                  bsDatepicker
                  [bsConfig]="{ dateInputFormat: 'MMM-DD-YYYY',showWeekNumbers: false }"
                  (keypress)="dobOnly($event)"
                />
                <div
                  *ngIf="
                    physicianForm.get('dateLastConsulted')?.invalid &&
                    (physicianForm.get('dateLastConsulted').dirty ||
                      physicianForm.get('dateLastConsulted')?.touched)
                  "
                >
                  <small
                    class="text-danger"
                    *ngIf="
                      physicianForm.get('dateLastConsulted').errors.required
                    "
                    >{{lang?.Date_is_required}}</small
                  >
                </div>
              </div>
            </div>
            <div class="col-12 col-md-7">
              <div class="form-group">
                <label for="reason_for_construction"
                  >{{lang?.Reason_for_consultation}}<span style="color: red"
                    >*</span
                  ></label
                >
                <input
                  type="text"
                  class="form-control text-capitalize"
                  id="reason_for_construction"
                  placeholder="{{lang?.Reason_for_consultation}}"
                  formControlName="consultationReason"
                />
                <div
                  *ngIf="
                    physicianForm.get('consultationReason')?.invalid &&
                    (physicianForm.get('consultationReason').dirty ||
                      physicianForm.get('consultationReason')?.touched)
                  "
                >
                  <small
                    class="text-danger"
                    *ngIf="
                      physicianForm.get('consultationReason').errors.required
                    "
                    >{{lang?.Reason_for_consultation_is_required}}</small
                  >
                </div>
              </div>
            </div>
          </div>
          <!-- Results -->
          <div class="row">
            <div class="col-12 col-md-12">
              <div class="form-group">
                <label for="results_prescribed"
                  >{{lang?.Results_e_g_normal_diagnosis_treatment_or_medication_prescribed}}<span style="color: red">*</span></label
                >
                <input
                  type="text"
                  class="form-control text-capitalize"
                  id="results_prescribed"
                  placeholder="{{lang?.Results_e_g_normal_diagnosis_treatment_or_medication_prescribed}}"
                  formControlName="consultationResult"
                />
                <div
                  *ngIf="
                    physicianForm.get('consultationResult')?.invalid &&
                    (physicianForm.get('consultationResult').dirty ||
                      physicianForm.get('consultationResult')?.touched)
                  "
                >
                  <small
                    class="text-danger"
                    *ngIf="
                      physicianForm.get('consultationResult').errors.required
                    "
                    >{{lang?.Results_are_required}}</small
                  >
                </div>
              </div>
            </div>
          </div>
        </form>

        <div *ngIf="isSpouse">
          <p style="font-weight: bold; margin-top:15px">
            {{lang?.Spouse_s_Personal_Physician_Information}}
          </p>
                    <form [formGroup]="physicianForm1">
            <!-- Personal Physician's Name -->
            <div class="row">
              <div class="col-12 col-md-8">
                <div class="form-group">
                  <label for="Personal_Physician_Name"
                    >{{lang?.Personal_Physician_s_Name}}<span style="color: red"
                      >*</span
                    ></label
                  >
                  <input
                    type="text"
                    class="form-control text-capitalize"
                    id="Personal_Physician_Name"
                    placeholder="{{lang?.Personal_Physician_s_Name}}"
                    formControlName="name"
                  />
                  <div
                    *ngIf="
                      physicianForm1.get('name')?.invalid &&
                      (physicianForm1.get('name').dirty ||
                        physicianForm1.get('name')?.touched)
                    "
                  >
                    <small
                      class="text-danger"
                      *ngIf="physicianForm1.get('name').errors.required"
                      >{{lang?.Name_is_required}}</small
                    >
                  </div>
                </div>
              </div>
              <!-- Telephone -->
              <div class="col-12 col-md-4">
                <div class="form-group">
                  <label for="Telephone"
                    >{{lang?.Telephone}}<span style="color: red">*</span></label
                  >
                  <input
                    type="text"
                    class="form-control"
                    id="Telephone"
                    placeholder="{{lang?.Telephone}}"
                    formControlName="number"
                    maxlength="17"
                  />
                  <div
                    *ngIf="
                      physicianForm1.get('number')?.invalid &&
                      (physicianForm1.get('number').dirty ||
                        physicianForm1.get('number')?.touched)
                    "
                  >
                    <small
                      class="text-danger"
                      *ngIf="physicianForm1.get('number').errors.required"
                      >{{lang?.Telephone_is_required}}</small
                    >
                  </div>
                  <small
                    class="text-danger"
                    *ngIf="
                      physicianForm1
                        .get('number')
                        ?.hasError('invalidPhoneNumber')
                    "
                  >
                    {{lang?.Telephone_should_contain_exactly_10_digits}}
                  </small>
                </div>
              </div>
            </div>
            <!-- Address Details -->
            <div class="row">
              <div class="col-12 col-md-5">
                <div class="form-group">
                  <label for="Street_Address"
                    >{{lang?.Street_Address}}<span style="color: red">*</span></label
                  >
                  <input
                    type="text"
                    class="form-control text-capitalize"
                    id="Street_Address"
                    placeholder="{{lang?.Street_Address}}"
                    formControlName="streetAddress"
                  />
                  <div
                    *ngIf="
                      physicianForm1.get('streetAddress')?.invalid &&
                      (physicianForm1.get('streetAddress').dirty ||
                        physicianForm1.get('streetAddress')?.touched)
                    "
                  >
                    <small
                      class="text-danger"
                      *ngIf="
                        physicianForm1.get('streetAddress').errors.required
                      "
                      >{{lang?.Street_Address_is_required}}</small
                    >
                  </div>
                </div>
              </div>
              <div class="col-12 col-md-3">
                <div class="form-group">
                  <label for="City"
                    >{{lang?.City}}<span style="color: red">*</span></label
                  >
                  <input
                    type="text"
                    class="form-control text-capitalize"
                    id="City"
                    placeholder="{{lang?.City}}"
                    formControlName="city"
                  />
                  <div
                    *ngIf="
                      physicianForm1.get('city')?.invalid &&
                      (physicianForm1.get('city').dirty ||
                        physicianForm1.get('city')?.touched)
                    "
                  >
                    <small
                      class="text-danger"
                      *ngIf="physicianForm1.get('city').errors.required"
                      >{{lang?.City_is_required}}</small
                    >
                  </div>
                </div>
              </div>
              <div class="col-12 col-md-2">
                <div class="form-group">
                  <label for="Province"
                    >{{lang?.Province}}<span style="color: red">*</span></label
                  >
                  <select
                    class="form-control"
                    id="Province"
                    formControlName="province"
                  >
                    <option value disabled>Select</option>
                    <option *ngFor="let province of provinceList">
                      {{ province }}
                    </option>
                  </select>
                  <div
                    *ngIf="
                      physicianForm1.get('province')?.invalid &&
                      (physicianForm1.get('province').dirty ||
                        physicianForm1.get('province')?.touched)
                    "
                  >
                    <small
                      class="text-danger"
                      *ngIf="physicianForm1.get('province').errors.required"
                      >{{lang?.Province_is_required}}</small
                    >
                  </div>
                </div>
              </div>
              <div class="col-12 col-md-2">
                <div class="form-group">
                  <label for="Postal_Code"
                    >{{lang?.Postal_Code}}<span style="color: red">*</span></label
                  >
                  <input
                    type="text"
                    class="form-control"
                    id="Postal_Code"
                    placeholder="{{lang?.Postal_Code}}"
                    formControlName="postalCode"
                    (input)="changeTextToUppercase($event)"
                  />
                  <div
                    *ngIf="
                      physicianForm1.get('postalCode')?.invalid &&
                      (physicianForm1.get('postalCode').dirty ||
                      physicianForm1.get('postalCode')?.touched)
                    "
                  >
                    <small
                      class="text-danger"
                      *ngIf="physicianForm1.get('postalCode').errors.required"
                      >{{lang?.Postal_Code_is_required}}</small
                    >
                                      </div>
                  <div class="help-block text-danger" 
                    *ngIf="((physicianForm1.get('postalCode').touched && physicianForm1.get('postalCode').hasError('invalidPostalCode')) || 
                      physicianForm1.get('postalCode').invalid || invalidpostalcodeprivince1)">
                    {{lang?.Enter_valid_Postal_Code}}
                  </div>
                </div>
              </div>
            </div>
            <!-- Consultation Details -->
            <div class="row">
              <div class="col-12 col-md-5">
                <div class="form-group">
                  <label for="date_last_consulted"
                    >{{lang?.Date_last_consulted_ANY_Doctor_dd_mmm_yyyy}}<span
                      style="color: red"
                      >*</span
                    ></label
                  >
                  <input
                    type="text"
                    placeholder="MM-DD-YYYY"
                    class="form-control"
                    formControlName="dateLastConsulted"
                    bsDatepicker
                    [bsConfig]="{ dateInputFormat: 'MMM-DD-YYYY',showWeekNumbers: false }"
                    (keypress)="dobOnly($event)"
                  />
                  <div
                    *ngIf="
                      physicianForm1.get('dateLastConsulted')?.invalid &&
                      (physicianForm1.get('dateLastConsulted').dirty ||
                        physicianForm1.get('dateLastConsulted')?.touched)
                    "
                  >
                    <small
                      class="text-danger"
                      *ngIf="
                        physicianForm1.get('dateLastConsulted').errors.required
                      "
                      >{{lang?.Date_is_required}}</small
                    >
                  </div>
                </div>
              </div>
              <div class="col-12 col-md-7">
                <div class="form-group">
                  <label for="reason_for_construction"
                    >{{lang?.Reason_for_consultation}}<span style="color: red"
                      >*</span
                    ></label
                  >
                  <input
                    type="text"
                    class="form-control text-capitalize"
                    id="reason_for_construction"
                    placeholder="{{lang?.Reason_for_consultation}}"
                    formControlName="consultationReason"
                  />
                  <div
                    *ngIf="
                      physicianForm1.get('consultationReason')?.invalid &&
                      (physicianForm1.get('consultationReason').dirty ||
                        physicianForm1.get('consultationReason')?.touched)
                    "
                  >
                    <small
                      class="text-danger"
                      *ngIf="
                        physicianForm1.get('consultationReason').errors.required
                      "
                      >{{lang?.Reason_for_consultation_is_required}}</small
                    >
                  </div>
                </div>
              </div>
            </div>
            <!-- Results -->
            <div class="row">
              <div class="col-12 col-md-12">
                <div class="form-group">
                  <label for="results_prescribed"
                    >{{lang?.Results_e_g_normal_diagnosis_treatment_or_medication_prescribed}}<span style="color: red">*</span></label
                  >
                  <input
                    type="text"
                    class="form-control text-capitalize"
                    id="results_prescribed"
                    placeholder="{{lang?.Results_e_g_normal_diagnosis_treatment_or_medication_prescribed}}"
                    formControlName="consultationResult"
                  />
                  <div
                    *ngIf="
                      physicianForm1.get('consultationResult')?.invalid &&
                      (physicianForm1.get('consultationResult').dirty ||
                        physicianForm1.get('consultationResult')?.touched)
                    "
                  >
                    <small
                      class="text-danger"
                      *ngIf="
                        physicianForm1.get('consultationResult').errors.required
                      "
                      >{{lang?.Results_are_required}}</small
                    >
                  </div>
                </div>
              </div>
            </div>
          </form>
                  </div>
        <!-- lincenseInfo Table -->
        <div class="d-block mb-5 mt-3">
                  </div>
      </div>

        <div
          class="modal"
          id="add_more"
          tabindex="-1"
          role="dialog"
          aria-labelledby="addMoreLabel"
          aria-hidden="true"
        >
          <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
              <div class="modal-header">
                <h6 class="modal-title">Add Question Details</h6>
                <button
                  type="button"
                  class="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div class="modal-body">
                <form
                  class="onbordingform"
                  [formGroup]="additionalDetailsform"
                  (ngSubmit)="addQuestion()"
                >
                  <div class="input-wrapper row">
                    <div class="form-group col-12 md-4">
                      <label for="Corporation" class="Corporation"
                        >Question Number<span style="color: red">*</span></label
                      >
                      <input
                        type="text"
                        class="form-control checking-field"
                        id="questionNumber"
                        placeholder="Question Number"
                        formControlName="questionNumber"
                      />
                      <div
                        *ngIf="
                          additionalDetailsform.controls['questionNumber']
                            .touched &&
                          additionalDetailsform.controls['questionNumber']
                            .invalid
                        "
                        class="help-block text-danger"
                      >
                        <div
                          *ngIf="additionalDetailsform.controls['questionNumber'].errors?.['required']"
                        >
                          Please enter a Question Number.
                        </div>
                        <div
                          *ngIf="additionalDetailsform.controls['questionNumber'].errors?.['min']"
                        >
                          Question Number must be at least 1.
                        </div>
                        <div
                          *ngIf="additionalDetailsform.controls['questionNumber'].errors?.['max']"
                        >
                          Question Number must be at most 23.
                        </div>
                        <div
                          *ngIf="additionalDetailsform.controls['questionNumber'].errors?.['duplicate']"
                        >
                          Question Number already exists.
                        </div>
                        <div
                          *ngIf="additionalDetailsform.controls['questionNumber'].errors?.['cannotAdd']"
                        >
                          Cannot add details to this question number.
                        </div>
                      </div>
                    </div>
                    <div class="form-group col-12 md-4">
                      <label for="Corporation" class="Corporation"
                        >Name of person to be insured<span style="color: red"
                          >*</span
                        ></label
                      >
                      <input
                        type="text"
                        class="form-control checking-field"
                        id="value"
                        placeholder="Name of person to be insured"
                        formControlName="value"
                        (keypress)="alphabatesOnly($event)"
                      />

                      <div
                        *ngIf="
                          additionalDetailsform['value']?.touched &&
                          additionalDetailsform['value']?.invalid
                        "
                        class="help-block text-danger"
                      >
                        Please enter Name of person to be insured
                      </div>
                    </div>
                  </div>
                  <div class="form-group col-12 md-4">
                    <label for="Corporation" class="Corporation"
                      >Details<span style="color: red">*</span></label
                    >

                    <input
                      type="text"
                      class="form-control checking-field"
                      id="additionalDetails"
                      placeholder="Details"
                      formControlName="additionalDetails"
                      (keypress)="alphabatesOnly($event)"
                    />

                    <div
                      *ngIf="
                        additionalDetailsform['additionalDetails']?.touched &&
                        additionalDetailsform['additionalDetails']?.invalid
                      "
                      class="help-block text-danger"
                    >
                      Please enter Details
                    </div>
                  </div>
                </form>
              </div>
              <div class="modal-footer">
                <button
                  type="button"
                  class="btn btn-secondary"
                  id="closeaddadmin"
                  data-bs-dismiss="modal"
                  #closemodel
                  (click)="closeMore()"
                >
                  Close
                </button>
                <button
                  type="button"
                  class="btn btn-primary"
                  [disabled]="additionalDetailsform.invalid"
                  (click)="
                    spouseEdit
                      ? SaveadditionalDetails1()
                      : SaveadditionalDetails()
                  "
                >
                  Save
                </button>
              </div>
            </div>
          </div>
        </div>

        <div
          class="modal"
          id="edit_question"
          tabindex="-1"
          role="dialog"
          aria-labelledby="editQuestionLabel"
          aria-hidden="true"
        >
          <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
              <div class="modal-header">
                <h6 class="modal-title">Edit Question Details</h6>
                <button
                  type="button"
                  class="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div class="modal-body">
                <form
                  class="onbordingform"
                  [formGroup]="additionalDetailsform"
                  (ngSubmit)="editQuestion()"
                >
                  <div class="input-wrapper row">
                    <div class="form-group col-12 md-4">
                      <label for="Corporation" class="Corporation"
                        >Question Number<span style="color: red">*</span></label
                      >
                      <input
                        type="text"
                        class="form-control checking-field"
                        id="questionNumber"
                        placeholder="Question Number"
                        formControlName="questionNumber"
                      />
                      <div
                        *ngIf="
                          additionalDetailsform.controls['questionNumber']
                            .touched &&
                          additionalDetailsform.controls['questionNumber']
                            .invalid
                        "
                        class="help-block text-danger"
                      >
                        <div
                          *ngIf="additionalDetailsform.controls['questionNumber'].errors?.['required']"
                        >
                          Please enter a Question Number.
                        </div>
                        <div
                          *ngIf="additionalDetailsform.controls['questionNumber'].errors?.['min']"
                        >
                          Question Number must be at least 1.
                        </div>
                        <div
                          *ngIf="additionalDetailsform.controls['questionNumber'].errors?.['max']"
                        >
                          Question Number must be at most 23.
                        </div>
                        <div
                          *ngIf="additionalDetailsform.controls['questionNumber'].errors?.['notFound']"
                        >
                          Question Number not Found.
                        </div>
                      </div>
                    </div>
                    <div class="form-group col-12 md-4">
                      <label for="Corporation" class="Corporation"
                        >Name of person to be insured<span style="color: red"
                          >*</span
                        ></label
                      >
                      <input
                        type="text"
                        class="form-control checking-field"
                        id="value"
                        placeholder="Name of person to be insured"
                        formControlName="value"
                        (keypress)="alphabatesOnly($event)"
                      />

                      <div
                        *ngIf="
                          additionalDetailsform['value']?.touched &&
                          additionalDetailsform['value']?.invalid
                        "
                        class="help-block text-danger"
                      >
                        Please enter Name of person to be insured
                      </div>
                    </div>
                  </div>
                  <div class="form-group col-12 md-4">
                    <label for="Corporation" class="Corporation"
                      >Details<span style="color: red">*</span></label
                    >

                    <input
                      type="text"
                      class="form-control checking-field"
                      id="additionalDetails"
                      placeholder="Details"
                      formControlName="additionalDetails"
                      (keypress)="alphabatesOnly($event)"
                    />

                    <div
                      *ngIf="
                        additionalDetailsform['additionalDetails']?.touched &&
                        additionalDetailsform['additionalDetails']?.invalid
                      "
                      class="help-block text-danger"
                    >
                      Please enter Details
                    </div>
                  </div>
                </form>
              </div>
              <div class="modal-footer">
                <button
                  type="button"
                  class="btn btn-secondary"
                  id="closeaddadmin"
                  data-bs-dismiss="modal"
                  #closemodel
                  (click)="closeEdit()"
                >
                  {{lang?.Close}}
                </button>
                <button
                  type="button"
                  class="btn btn-primary"
                  [disabled]="additionalDetailsform.invalid"
                  (click)="
                    spouseEdit
                      ? updateAdditionalDetails1()
                      : updateAdditionalDetails()
                  "
                >
                  Save
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer py-2">
        <button
          type="button"
          class="btn btn-sm btn-light"
          data-bs-dismiss="modal"
          id="cancelButton"
        >
          {{lang?.Cancel}}</button
        >&nbsp;
        <button
          type="button"
          class="btn btn-sm btn-light"
          id="submitButton"
          (click)="handleSubmit()"
        >
          {{lang?.Submit}}
        </button>
      </div>
    </div>
  </div>
</div>
